"use client";
import { MemberType } from "../../../../../types";
import React from "react";
import Button from "../../../ui/Button";
import Link from "next/link";
import { usePathname, useSearchParams } from "next/navigation";
import Image from "next/image";
import { generateSlugWithId } from "src/app/serverUtils";
import { capitalizeWords } from "src/app/components/utils";
import { VerifiedBadge } from "src/app/components/Icon";
type Member = MemberType extends { className?: string }
  ? MemberType
  : MemberType & { className?: string };

export const TeamCard: React.FC<Member> = ({
  name,
  id,
  email,
  phone,
  image,
  is_verified,
  role,
  className,
}) => {
  const slugwithid = generateSlugWithId(Number(id), name);
  return (
    <div
      style={{
        boxShadow: "0px 2px 10px 0px #2121210D",
      }}
      className={`text-secondary-main flex flex-col mx-auto gap-5 items-center pt-[7rem] pb-5 min-w-[300px] max-w-[480px] shrink-0 bg-white rounded-2xl relative ${className}`}
    >
      <div
        style={{
          top: "-6rem",
        }}
        className="image size-[12rem] bg-themeColor-70  flex justify-center  overflow-hidden absolute left-1/2 -translate-x-1/2 rounded-full"
      >
        <Image
          height={200}
          width={200}
          className="object-cover"
          loading="lazy"
          src={image || "/images/person-2.webp"}
          alt="user image"
        />
      </div>
      <div className="first w-full border-b border-b-themeColor mb-2 pb-8">
        <Link
          href={`/staff/${slugwithid}`}
          className="text-themeColor flex justify-center items-center gap-2 hover:underline h4 font-medium line-clamp-1 text-center"
        >
          {name} <VerifiedBadge verified={is_verified as boolean} />
        </Link>
        <h4 className="text-secondary-main h5 text-capitalize text-center">
          {role}
        </h4>
      </div>

      <div className="second flex flex-col items-center gap-1 mb-6">
        {phone && (
          <h6 className="flex items-center gap-1">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_1580_101109)">
                <path
                  d="M11.875 3.75C12.9262 4.02681 13.8851 4.57767 14.6537 5.34631C15.4223 6.11494 15.9732 7.07382 16.25 8.125"
                  fill="#2F364B"
                />
                <path
                  d="M11.875 3.75C12.9262 4.02681 13.8851 4.57767 14.6537 5.34631C15.4223 6.11494 15.9732 7.07382 16.25 8.125"
                  stroke="#2F364B"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.25 6.25C12.5406 6.59531 13.4047 7.45937 13.75 8.75L11.25 6.25Z"
                  fill="#2F364B"
                />
                <path
                  d="M11.25 6.25C12.5406 6.59531 13.4047 7.45937 13.75 8.75"
                  stroke="#2F364B"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12.218 11.9799C12.3045 11.9223 12.4041 11.8872 12.5076 11.8778C12.6112 11.8683 12.7154 11.8849 12.8109 11.9259L16.4953 13.5767C16.6195 13.6298 16.7231 13.7217 16.7907 13.8385C16.8583 13.9554 16.8862 14.0911 16.8703 14.2252C16.7489 15.1322 16.3023 15.9643 15.6133 16.5668C14.9244 17.1692 14.0402 17.5009 13.125 17.5002C10.3071 17.5002 7.60457 16.3807 5.61199 14.3882C3.61942 12.3956 2.5 9.69309 2.5 6.87517C2.4993 5.96001 2.831 5.07575 3.43341 4.38683C4.03582 3.69791 4.86793 3.25123 5.775 3.12985C5.90909 3.11392 6.04473 3.14185 6.16162 3.20945C6.27851 3.27705 6.37037 3.38069 6.42344 3.50485L8.07422 7.19235C8.11478 7.28706 8.1313 7.39033 8.1223 7.49297C8.1133 7.5956 8.07907 7.69442 8.02266 7.78063L6.35313 9.76579C6.2939 9.85515 6.25888 9.95835 6.25149 10.0653C6.24409 10.1722 6.26458 10.2793 6.31094 10.3759C6.95703 11.6986 8.32422 13.0494 9.65078 13.6892C9.74795 13.7354 9.85548 13.7554 9.96276 13.7473C10.07 13.7392 10.1733 13.7033 10.2625 13.6431L12.218 11.9799Z"
                  fill="#2F364B"
                  stroke="white"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_1580_101109">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <Link className="" href={`tel:${phone}`}>
              {phone}
            </Link>
          </h6>
        )}

        {email && (
          <h6 className="flex  items-center gap-1">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="20" height="20" rx="4" fill="#2F364B" />
              <path
                d="M5.33341 5.3335H14.6667C15.3084 5.3335 15.8334 5.8585 15.8334 6.50016V13.5002C15.8334 14.1418 15.3084 14.6668 14.6667 14.6668H5.33341C4.69175 14.6668 4.16675 14.1418 4.16675 13.5002V6.50016C4.16675 5.8585 4.69175 5.3335 5.33341 5.3335Z"
                stroke="white"
                stroke-width="1.04347"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M15.8334 6.5L10.0001 10.5833L4.16675 6.5"
                stroke="white"
                stroke-width="1.04347"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <Link href={`mailto:${email}`}>{email}</Link>
          </h6>
        )}
      </div>

      <Button
        href={`/staff/${slugwithid}`}
        className="bg-themeColor primary-btn !px-8 !py-3 !text-white"
      >
        View Profile
      </Button>
    </div>
  );
};

export const TeamCardWhatsapp: React.FC<MemberType> = ({
  name,
  id,
  email,
  phone,
  image,
  role,
  is_verified,
}) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const fullUrl =
    typeof window !== "undefined"
      ? `${window.location.origin}${pathname}?${searchParams.toString()}`
      : "";
  const slug = generateSlugWithId(id, name);
  const cleanPhone = phone.replace(/\D/g, "");
  return (
    <div
      style={{
        boxShadow: "0px 2px 10px 0px #2121210D",
      }}
      className="text-secondary-main flex flex-col gap-5 items-center pt-[9rem] pb-5 min-w-[300px] w-full shrink-0 bg-white rounded-md relative"
    >
      <div
        style={{
          top: "-6.5rem",
        }}
        className="image size-[13rem]  overflow-hidden absolute left-1/2 -translate-x-1/2 rounded-full"
      >
        <Image
          width={200}
          height={200}
          className="h-full bg-[rgba(var(--primary-color-rgb),0.7)] w-full object-cover"
          src={image || ""}
          alt=""
        />
      </div>
      <div className="first border-b mx-auto border-b-themeColor w-full pb-6">
        {name && (
          <h2 className="text-themeColor justify-center  hover:underline items-center flex gap-2 font-medium text-center">
            <Link href={`/staff/${slug}`}>{capitalizeWords(name)}</Link>{" "}
            <VerifiedBadge verified={is_verified as boolean} />
          </h2>
        )}

        <h5 className="text-secondary-main text-center">{role}</h5>
      </div>

      <div className="second flex flex-col items-center gap-1 mb-6">
        {phone && (
          <h6 className="flex gap-1">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_1580_101109)">
                <path
                  d="M11.875 3.75C12.9262 4.02681 13.8851 4.57767 14.6537 5.34631C15.4223 6.11494 15.9732 7.07382 16.25 8.125"
                  fill="#2F364B"
                />
                <path
                  d="M11.875 3.75C12.9262 4.02681 13.8851 4.57767 14.6537 5.34631C15.4223 6.11494 15.9732 7.07382 16.25 8.125"
                  stroke="#2F364B"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.25 6.25C12.5406 6.59531 13.4047 7.45937 13.75 8.75L11.25 6.25Z"
                  fill="#2F364B"
                />
                <path
                  d="M11.25 6.25C12.5406 6.59531 13.4047 7.45937 13.75 8.75"
                  stroke="#2F364B"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12.218 11.9799C12.3045 11.9223 12.4041 11.8872 12.5076 11.8778C12.6112 11.8683 12.7154 11.8849 12.8109 11.9259L16.4953 13.5767C16.6195 13.6298 16.7231 13.7217 16.7907 13.8385C16.8583 13.9554 16.8862 14.0911 16.8703 14.2252C16.7489 15.1322 16.3023 15.9643 15.6133 16.5668C14.9244 17.1692 14.0402 17.5009 13.125 17.5002C10.3071 17.5002 7.60457 16.3807 5.61199 14.3882C3.61942 12.3956 2.5 9.69309 2.5 6.87517C2.4993 5.96001 2.831 5.07575 3.43341 4.38683C4.03582 3.69791 4.86793 3.25123 5.775 3.12985C5.90909 3.11392 6.04473 3.14185 6.16162 3.20945C6.27851 3.27705 6.37037 3.38069 6.42344 3.50485L8.07422 7.19235C8.11478 7.28706 8.1313 7.39033 8.1223 7.49297C8.1133 7.5956 8.07907 7.69442 8.02266 7.78063L6.35313 9.76579C6.2939 9.85515 6.25888 9.95835 6.25149 10.0653C6.24409 10.1722 6.26458 10.2793 6.31094 10.3759C6.95703 11.6986 8.32422 13.0494 9.65078 13.6892C9.74795 13.7354 9.85548 13.7554 9.96276 13.7473C10.07 13.7392 10.1733 13.7033 10.2625 13.6431L12.218 11.9799Z"
                  fill="#2F364B"
                  stroke="white"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_1580_101109">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <Link href={`tel:${phone}`}>{phone || "Phone not available"}</Link>
          </h6>
        )}
        {email && (
          <h6 className="flex gap-1">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="20" height="20" rx="4" fill="#2F364B" />
              <path
                d="M5.33341 5.3335H14.6667C15.3084 5.3335 15.8334 5.8585 15.8334 6.50016V13.5002C15.8334 14.1418 15.3084 14.6668 14.6667 14.6668H5.33341C4.69175 14.6668 4.16675 14.1418 4.16675 13.5002V6.50016C4.16675 5.8585 4.69175 5.3335 5.33341 5.3335Z"
                stroke="white"
                stroke-width="1.04347"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M15.8334 6.5L10.0001 10.5833L4.16675 6.5"
                stroke="white"
                stroke-width="1.04347"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <Link href={`mailto:${email}`}>{email}</Link>
          </h6>
        )}
      </div>

      {phone && (
        <Button className="bg-themeColor primary-btn w-[90%] block mx-auto !text-white">
          <Link
            target="_blank"
            href={`https://wa.me/${cleanPhone}?text=Hello, I will like to enquire about this property on your website. ${fullUrl}`}
          >
            Message on WhatsApp
          </Link>
        </Button>
      )}
    </div>
  );
};
